import BaseButton from '@/components/BaseButton.vue';
import {
  ButtonEdit,
  ButtonLeftArrow,
  ButtonPreview,
  ButtonRedemptionStatus,
  ButtonRemove,
  ButtonUnpublish,
} from '@/components/button';
import CouponStocksModal from '@/components/coupon/CouponStocksModal.vue';
import StatusLabel from '@/components/StatusLabel.vue';
import vModelMixin from '@/mixins/v-model';
import getCouponStatus from '@/helpers/coupon-status';

const controlBarMixin = {
  mixins: [vModelMixin],
  components: {
    BaseButton,
    ButtonPreview,
    ButtonEdit,
    ButtonLeftArrow,
    ButtonRedemptionStatus,
    ButtonRemove,
    ButtonUnpublish,
    CouponStocksModal,
    StatusLabel,
  },
  props: {
    readOnly: {
      type: Boolean,
    },
    title: {
      type: String,
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit-click');
    },
    onCancel() {
      this.$emit('cancel-click');
    },
    onSave() {
      this.$emit('save-click');
    },
    isPermit(action) {
      const actions = this.availableActions[this.inputVal.reward.status];
      if (!actions) return false;
      return actions.indexOf(action) >= 0;
    },
  },
  computed: {
    status() {
      return getCouponStatus(this.inputVal.currentStatus?.status);
    },
  },
};

export default controlBarMixin;
